import Util from './RegistrationUtil'

export const RegistrationFields = {
    VISITOR_TYPE: 'visitortype',
    SCHOOL: 'school',
    US_POSTAL: 'us_postal',
    COUNTRY: 'country',
    GDPR_URL: 'gdpr_url',
    GPA: 'gpa',
}

export const RegistrationFieldClass = {
    VISITOR_TYPE: 'VisitorType',
    SCHOOL: 'School',
    ZIP_CODE: 'ZipCode',
    DROPDOWN: 'Dropdown',
    GDPR: 'GDPR',
    DATE: 'Date',
    EMAIL: 'Email',
    PHONE: 'Phone',
    TEXTBOX: 'TextBox',
    GPA: 'GPA',
}

function RegistrationField(opts) {
    this.registration = opts.registration
    this.form = opts.form
    this.onValueChange = opts.onValueChange || function(field, oldV, newV) {}

    this.definition = opts.definition
    this.id = opts.definition.fieldid
    this.list = opts.definition.list
    this.title = opts.definition.label
    this.tooltip = opts.definition.tooltip || opts.definition.report_title
    this.order = opts.definition.sort_order
    this.required = JSON.parse(opts.definition.required)
    this.showIf = opts.definition.show_if
    this.value = opts.definition.value || ''
    this.type = opts.definition.input_type

    this.$html = $(this._wrapHtml(this.buildHtml()))
    this.$error = opts.$error
}
RegistrationField.prototype = {
    getClassName: function() {
        return 'default'
    },

    focus: function() {
        this.registration.focusField(this.id)
    },

    blur: function() {
        this.registration.blurField(this.id)
    },

    setError: function(message) {
        this.$html.addClass('error').attr('error', message)
        //for visitor type
        this.$html.find('.visible_area').attr('aria-label', message)
        this.$html.find('label').html(message)
        var html = '<div class="msg" field="' + this.id + '">' + message + '</div>'
        this.$error.append(html).addClass('show')
    },

    clearError: function() {
        this.$html.removeClass('error').removeAttr('error')
        this.$error.html('').removeClass('show')
    },

    setValue: function(value) {
        var oldValue = this.value

        if (oldValue !== value) {
            this.value = value

            this.clearError()

            // callback on value change
            this.onValueChange(this, oldValue, value)

            // update all views except for date of birth on mobile (after initial render)
            if (this.tooltip !== 'Birthday' || (this.tooltip === 'Birthday' && !this.registration.mobile)) {
                this.registration.updateAllFieldViews({
                    key: this.id,
                    value: value,
                })
            }

            // show select when a choice has been made so that the placeholder text
            var select = this.$html.find('select')
            if (select) {
                if (value !== '') {
                    select.css('opacity', 1)
                }
            }
        }
    },

    getValue: function() {
        return this.value
    },

    isRelevant: function() {
        return this._isRelevant()
    },

    /**
     * Protected - override completely
     */
    buildHtml: function() {},

    /**
     * Protected - override completely
     */
    applyBindings: function() {},

    /**
     * Protected - override, call this base method first
     */
    updateView: function() {
        var show = this._isRelevant()
        if (!show) {
            this.clearError()
        }
        this.$html.toggleClass('show', show)
    },

    _wrapHtml: function(html) {
        var addVisibiltiyHidden = this.registration.isMaterialUI()
        return (
            '' +
            '<div class="registration-field ' +
            this.getClassName() +
            '" id="registration-' +
            this.id +
            '" title="' +
            this.title +
            '" fieldid="' +
            this.id +
            '">' +
            '<label for="' +
            this._getId() +
            '" ' +
            (addVisibiltiyHidden ? 'class="visuallyhidden">' : '>') +
            this._getLableText() +
            '</label>' +
            '<div class="field-content" title="' +
            this.title +
            (this.required ? ' *' : '') +
            '">' +
            html +
            '</div>' +
            '<div class="field-highlight"></div>' +
            '<div class="field-underline">' +
            this.registration.getSvg('dotted') +
            '</div>' +
            '</div>'
        )
    },
    _getPlaceholderText: function(ignoreRequired) {
        if (this.registration.disablePlaceholder) return ''
        if (this.registration.isMaterialUI()) return ''
        return "placeholder='" + Util.escape(this.title) + (!ignoreRequired && this.required ? ' *' : '') + "'"
    },
    _getAltText: function(ignoreRequired) {
        return (
            "alt='" +
            Util.escape(this.title) +
            (!ignoreRequired && this.required ? ' *' : '') +
            "' " +
            " aria-label='" +
            Util.escape(this.title) +
            "'"
        )
    },
    _getLableText: function() {
        return this.title
    },
    _getId: function() {
        return this._altID ? this._altID : this.id
    },
    _isRelevant: function() {
        var showIf = this.showIf
        for (var conditionStr in showIf) {
            var rightVal = showIf[conditionStr]

            // SPLIT FIELD AND OPERATOR
            var leftArray = conditionStr.split(' ')
            var leftFieldId = leftArray[0]
            var operator = leftArray[1]

            if (!operator) {
                operator = '='
            }

            var leftField = this.registration.getField(leftFieldId)
            if (!leftField) {
                return false
            }
            var leftVal = leftField.getValue()

            if (Array.isArray(rightVal)) {
                // checking if field value is in array

                if (operator == '!=') {
                    // if left value is in array, check fails
                    if (Util.softIndexOf(rightVal, leftVal) != -1) return false
                } else {
                    // if left value is missing from array, check fails
                    if (Util.softIndexOf(rightVal, leftVal) == -1) return false
                }
            } else {
                // checking field value equals right value

                if (operator == '!=') {
                    // if left value is equal to right, test fails
                    if (leftVal == rightVal) return false
                } else {
                    // if left value does not equal right, test fails
                    if (leftVal != rightVal) return false
                }
            }
        }
        return true
    },
}
export default RegistrationField
